import type { FC, ReactNode } from "react";

interface ActivePulseIndicatorProps {
  children?: ReactNode;
  className?: string;
  colorClassName?: string;
  radarClassName?: string;
  size?: "xs" | "sm" | "md" | "lg";
  pulse?: boolean;
  glow?: boolean;
}

const SIZE_CLASS_MAP: Record<
  NonNullable<ActivePulseIndicatorProps["size"]>,
  string
> = { lg: "h-3 w-3", md: "h-2.5 w-2.5", sm: "h-2 w-2", xs: "h-1.5 w-1.5" };

const RADAR_INSET_CLASS_MAP: Record<
  NonNullable<ActivePulseIndicatorProps["size"]>,
  string
> = { lg: "-inset-1", md: "-inset-1", sm: "-inset-1", xs: "-inset-0.5" };

export const ActivePulseIndicator: FC<ActivePulseIndicatorProps> = ({
  children,
  className = "",
  colorClassName = "bg-emerald-500",
  radarClassName = "border-emerald-500/50",
  size = "sm",
  pulse = true,
  glow = false,
}) => {
  const glowClass = glow ? "shadow-[0_0_12px_rgba(16,185,129,0.6)]" : "";
  const pulseClass = pulse ? "animate-pulse" : "";

  return (
    <span
      aria-hidden="true"
      className={`relative inline-flex ${SIZE_CLASS_MAP[size]} ${className}`.trim()}
    >
      {pulse && (
        <span
          className={`absolute ${RADAR_INSET_CLASS_MAP[size]} animate-ping rounded-none border ${radarClassName}`}
        />
      )}
      {children ?? (
        <span
          className={`relative inline-flex h-full w-full rounded-none ${colorClassName} ${glowClass} ${pulseClass}`
            .trim()
            .replace(/\s+/g, " ")}
        />
      )}
    </span>
  );
};
